import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const ArrowsHorizontalIcon = ({
    size = 16,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill={color}>
        <path d="M10.856 4.464a.375.375 0 0 0 .006.536l2.287 2.187H2.851L5.138 5a.375.375 0 0 0 .006-.536l-.614-.613a.375.375 0 0 0-.53 0L.11 7.735a.375.375 0 0 0 0 .53L4 12.15a.375.375 0 0 0 .53 0l.614-.613A.375.375 0 0 0 5.138 11L2.851 8.812h10.298L10.862 11a.375.375 0 0 0-.006.536l.614.613a.375.375 0 0 0 .53 0l3.89-3.884a.375.375 0 0 0 0-.53L12 3.85a.375.375 0 0 0-.53 0l-.614.613Z"/>
    </svg>
);
ArrowsHorizontalIcon.displayName = 'ArrowsHorizontalIcon';
export default ArrowsHorizontalIcon;
